import React, { useEffect, useState } from 'react';
import { View, Text, Image, StyleSheet, FlatList, TouchableOpacity } from 'react-native';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { TABLE_RESERVATION_LIST_DETAILS } from '../../navigation/StackNavigator/routes';
import { ImageComp } from '../../components/Image/Image';
import { useDispatch, useSelector } from 'react-redux';
import { getCleanUrl } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import { CHEVRON_RIGHT } from '../../assets';
import { get7roomsRestaurantReservationData, getMyReservationData } from '../../Redux/Actions/tableReservationAction';
import { useTranslation } from 'react-i18next';
import { getDataLoadingScreen } from '../../js/getDataLoadingScreen';

const TableReservation = ({navigation}) => {

 
  const dispatch = useDispatch()
  const {t} = useTranslation();

  const {currentWidget} = useSelector(
    state => state.deviceConfigSlice,
  );
  const tableReservationSlice = useSelector(state => state.tableReservationSlice);

  const allVenueData = tableReservationSlice.allVenues.allVenueData;
  const loading = tableReservationSlice.allVenues.loading;
  const myReservationData = tableReservationSlice.myReservations.myReservationData;

  console.log('MY RESERVATION DATA', myReservationData);

  const imgUrl = getCleanUrl(currentWidget?.widgetHeaderImageUrl)
  const getStyles = useCssStyle();

  const handleItemListPress = (item) => {

     navigation.navigate(TABLE_RESERVATION_LIST_DETAILS, { item })
     
  }

  useEffect(() => {

    if (!allVenueData || allVenueData.length === 0) {

      dispatch(get7roomsRestaurantReservationData());
    }
    dispatch(getMyReservationData());

  }, [dispatch, allVenueData])


  const renderItem = ({ item }) => (
    <TouchableOpacity style={getStyles(['itemList'])} onPress={() => handleItemListPress(item)}>
      <Text style={getStyles(['itemText'])}> {item.name}</Text>
      <View style={getStyles(['listViewItemArrow'])}>
        <ImageComp source={CHEVRON_RIGHT}/>
      </View>
    </TouchableOpacity>
  );



  return (
    <View style={getStyles(['mainContainer'])}>
      <HeaderWithBack navigation = {navigation} />

      {loading && allVenueData.length === 0 ? (
                getDataLoadingScreen()
            ) : (
                <FlatList
                    data={allVenueData}
                    renderItem={renderItem}
                    keyExtractor={(item) => item.id}
                    ListHeaderComponent={
                        <>
                            <ImageComp source={imgUrl} style={getStyles(['mainImageStyle'])} />
                            <Text style={getStyles(['headerTitle'])}>{t('tableRes.reservation')}</Text>
                        </>
                    }
                    showsVerticalScrollIndicator={false}
                />
            )}
    </View>
  );
};

export default TableReservation;
